// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function use(query) {
  let match = React.useState(() => window.matchMedia(query).matches);
  let setMatched = match[1];
  React.useEffect(() => {
    let mediaQueryList = window.matchMedia(query);
    setMatched(param => mediaQueryList.matches);
    let handler = () => setMatched(param => mediaQueryList.matches);
    mediaQueryList.addListener(handler);
    return () => {
      mediaQueryList.removeListener(handler);
    };
  }, [query]);
  return match[0];
}

export {
  use,
}
/* react Not a pure module */
